<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            default="today"
            type="year"
            label="년도"
            name="year"
            v-model="searchParam.year"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            type="search"
            stepperGrpCd="SOP_FIRE_FIGHTING_TRANING_EDU_YEAR_STEP_CD"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="sopFireFightingTraningEduYearStepCd"
            label="진행단계"
            v-model="searchParam.sopFireFightingTraningEduYearStepCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="소방 연간 훈련·교육 계획 목록"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn v-if="editable" label="등록" icon="add" @btnClicked="openPop" />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'fireFightingTraningEduYear',
  data() {
    return {
      searchParam: {
        plantCd: null,
        period: [],
        sopFireFightingTraningEduYearStepCd: null,
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'planYear',
            field: 'planYear',
            label: '년도',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
            type: 'link'
          },
          {
            name: 'sopFireFightingTraningEduYearStepName',
            field: 'sopFireFightingTraningEduYearStepName',
            label: '진행상태',
            align: 'center',
            sortable: true,
            style: 'width: 120px',
          },
          {
            name: 'worker',
            field: 'worker',
            label: '근무자',
            child: [
              {
                name: 'workerFlag',
                field: 'workerFlag',
                label: '여부',
                align: 'center',
                sortable: true,
                style: 'width: 70px',
              },
              {
                name: 'workerCount',
                field: 'workerCount',
                label: '인원수(명)',
                align: 'right',
                sortable: true,
                style: 'width: 110px',
                type: 'cost'
              },
            ],
          },
          {
            name: 'self',
            field: 'self',
            label: '자위소방대 및 초기대응체계',
            child: [
              {
                name: 'selfFlag',
                field: 'selfFlag',
                label: '여부',
                align: 'center',
                sortable: true,
                style: 'width: 70px',
              },
              {
                name: 'selfCount',
                field: 'selfCount',
                label: '인원수(명)',
                align: 'right',
                sortable: true,
                style: 'width: 110px',
                type: 'cost'
              },
            ],
          },
          {
            name: 'resident',
            field: 'resident',
            label: '거주자',
            child: [
              {
                name: 'residentFlag',
                field: 'residentFlag',
                label: '여부',
                align: 'center',
                sortable: true,
                style: 'width: 70px',
              },
              {
                name: 'residentCount',
                field: 'residentCount',
                label: '인원수(명)',
                align: 'right',
                sortable: true,
                style: 'width: 110px',
                type: 'cost'
              },
            ],
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: false,
        width: '80%',
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.fft.fireFightingTraningEduYear.list.url
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    openPop() {
      this.linkClick();
    },
    linkClick(row) {
      this.popupOptions.title = '소방 연간 훈련·교육 계획 상세';
      this.popupOptions.param = {
        sopFireFightingTraningEduYearId: row ? row.sopFireFightingTraningEduYearId : '',
      };
      this.popupOptions.target = () => import(`${'./fireFightingTraningEduYearDetail.vue'}`);
      this.popupOptions.width = '70%';
      this.popupOptions.isFull = false;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
